
import {BasicCommand, BasicController, BasicLayoutManager, CommandController} from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { BasicStandardOkDialogProperties } from "@goodgamestudios/core";
import { BasicSocialData } from '@goodgamestudios/core';

import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2UserEvent } from "../../../event/Poker2UserEvent";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2WarningDialog } from "../../../view/dialogs/Poker2WarningDialog";
import { Poker2LayoutManager } from "../../../view/Poker2LayoutManager";
import { Poker2Command } from "../Poker2Command";

export class LGNCommand extends Poker2Command {
    protected get cmdId(): string {
        return "lgn";
    }

    public executeCommand(error: number, params: any[]): boolean {

        if (this.env.isSSO) {
            let command: BasicCommand = BasicController.commandDict.get(SFConstants.S2C_SOCIAL_LOGIN);
            return command.executeCommand(error, params);
        }

        switch (error) {
            case 0:
                Poker2Model.userData.registeredInThisSession = false;
                this.env.isFirstVisit = false;
                Poker2Model.userData.guestName = "";
                Poker2Model.userData.firstLogin = false;
                this.layoutManager.onEndProgressbar();
                BasicModel.smartfoxClient.sendMessage("lgr", []);
                Poker2Model.localData.saveCookieExists();
                Poker2Model.sessionData.loggedIn = true;
                return true;
            case 21:
            case 20:
                this.layoutManager.showDialog("Poker2WarningDialog", new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_alert_bug"), Poker2Model.languageData.getTextById("generic_login_wronglogin")));
                Poker2Model.localData.saveLoginData("", "", false);
                this.layoutManager.onEndProgressbar();
                this.layoutManager.state = BasicLayoutManager.STATE_LOGIN;
                break;
            case 26:
                Poker2LayoutManager.getInstance().state = BasicLayoutManager.STATE_AVATAR_CREATION;
                break;
            case 17:
                Poker2Model.userData.firstLogin = true;
                this.layoutManager.onEndProgressbar();
                BasicModel.smartfoxClient.sendMessage("lgr", []);
                Poker2Model.localData.saveCookieExists();
                break;
            case 27:
                this.layoutManager.showDialog("Poker2WarningDialog", new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_alert_information"), Poker2Model.languageData.getTextById("generic_login_banned")));
                Poker2Model.localData.saveLoginData("", "", false);
                this.layoutManager.onEndProgressbar();
                this.layoutManager.state = BasicLayoutManager.STATE_LOGIN;
                break;
        }
        if (this.env.loginIsKeyBased)
            Poker2Model.socialData.postFeed(BasicSocialData.EXTERNAL_TRIGGER_ERROR, [error, Poker2Model.userData.userID]);

        this.controller.dispatchEvent(new Poker2UserEvent("logginFaild"));
        return super.executeCommand(error, params);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
